import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React from "react";
import MyText from "./MyText";
import { primary, white } from "../../colors";
import Loading from "../animation/Loading";
export default function MyButton(props) {
  return (
    <TouchableOpacity
      {...props}
      onPress={props.onPress}
      style={[styles.container, props.style]}
    >
      {props.loading !== undefined && props.loading === true ? (
        <Loading />
      ) : (
        <MyText style={{ ...styles.text, ...props.textStyle }}>
          {props.text}
        </MyText>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 5,
    paddingHorizontal: 20,
    backgroundColor: primary,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",

    borderRadius: 10,
  },
  text: {
    fontSize: 16,
    fontWeight: "400",
    color: white,
  },
});
